import React from 'react';
import * as stylex from '@stylexjs/stylex';
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import AuditLogs from "src/routes/app/audit-log/AuditLogs";
import AuditLog from "src/routes/app/audit-log/AuditLog";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
export default function AuditLogIndex(props) {
  var id = useURLParam("id");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Logs"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    defaultHighlight: "list",
    queryFilter: "do",
    menuItems: [{
      id: "list",
      label: "Logs",
      content: /*#__PURE__*/React.createElement(AuditLogs, null),
      icon: "menu",
      queryString: {
        id: undefined
      }
    }, {
      id: "view",
      label: "View",
      content: /*#__PURE__*/React.createElement(AuditLog, null),
      icon: "eye",
      show: id !== null
    }]
  }));
}

// @ts-ignore